import { Card, Typography, Box, Divider, Chip, styled } from '@mui/material';

export const StyledCard = styled(Card)({
  marginTop: '24px',
  marginBottom: '24px',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: 'white',
  boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
});

export const HeaderBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '16px',
});

export const HeaderIcon = styled('span')({
  fontSize: '28px',
});

export const HeaderTitle = styled(Typography)({
  fontWeight: 600,
});

export const StyledDivider = styled(Divider)({
  borderColor: 'rgba(255,255,255,0.2)',
  marginBottom: '16px',
});

export const InfoItemBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '12px',
  backgroundColor: 'rgba(255,255,255,0.1)',
  borderRadius: '8px',
  transition: 'background-color 0.2s ease',
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.15)',
  },
});

export const LabelBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const LabelIcon = styled('span')({
  fontSize: '20px',
});

export const LabelText = styled(Typography)({
  fontWeight: 500,
});

export const ValueText = styled(Typography)({
  fontWeight: 600,
});

export const UptimeChip = styled(Chip)({
  backgroundColor: 'rgba(0,0,0,0.3)',
  color: 'white',
  fontFamily: 'monospace',
  fontWeight: 600,
  fontSize: '0.85rem',
});
